// 세 유형 마커의 순서는 저장된 중복 번호를 정리할 때의 우선순위이기도 하다.
export const B4_MARKER_FIELDS = [
  { numberKey: 'b4Marker5', labelKey: 'b4Marker5Label' },
  { numberKey: 'b4MarkerShort', labelKey: 'b4MarkerShortLabel' },
  { numberKey: 'b4MarkerCustom', labelKey: 'b4MarkerCustomLabel' },
];

// 한 줄 마커 박스가 B4 문제 칼럼 안에 들어가도록 입력 길이를 제한한다.
export const B4_MARKER_LABEL_MAX_LENGTH = 16;

export function uniqueB4MarkerNumbers(prefs) {
  const taken = new Set();
  const numbers = {};
  B4_MARKER_FIELDS.forEach(({ numberKey }) => {
    const value = prefs[numberKey];
    numbers[numberKey] = value !== 'none' && taken.has(value) ? 'none' : value;
    if (numbers[numberKey] !== 'none') taken.add(numbers[numberKey]);
  });
  return numbers;
}

export function isB4MarkerNumberTaken(numbers, numberKey, number) {
  return B4_MARKER_FIELDS.some((field) => field.numberKey !== numberKey
    && numbers[field.numberKey] === String(number));
}

// 인쇄 오버레이와 시험지 조립 지면이 같은 마커 목록을 사용한다.
export function b4MarkersForSheet(prefs, problemCount) {
  const numbers = uniqueB4MarkerNumbers(prefs);
  return B4_MARKER_FIELDS.map(({ numberKey, labelKey }) => {
    const label = typeof prefs[labelKey] === 'string'
      ? prefs[labelKey].slice(0, B4_MARKER_LABEL_MAX_LENGTH).trim() : '';
    const value = numbers[numberKey];
    const number = Number(value);
    const problemNo = label && value !== 'none' && Number.isInteger(number)
      && number >= 1 && number <= problemCount ? number : null;
    return { label, problemNo };
  });
}
